/* jscs:disable requireSpacesInsideJsxExpressionContainers */

import React from 'react';
import PropTypes from 'prop-types';
import Component from '@ux/component';
import { TrayTitle } from '@ux/tray-menu';
import { golf } from '../enums';
import eidBuilder from '../eid';
import { IntlProvider, FormattedMessage } from 'react-intl';
import Link from '@ux/link';

/**
 * Render signIn section.
 *
 * @Constructor
 * @class SignIn
 * @api public
 */
class SignIn extends Component {
  constructor(props) {
    super(...arguments);

    this.eids = {
      login: eidBuilder({
        key: golf.login,
        manifest: props.manifest
      })
    };
  }

  render() {
    const props = this.props;
    const eids = this.eids;

    return (
      <IntlProvider locale={ props.market } messages={ props.messages }>
        <div
          className='col-xl-7 push-xl-5 col-lg-6 push-lg-6 col-md-6 sign-in divider'>
          <TrayTitle>
            <FormattedMessage id={ golf.registeredUser } />
          </TrayTitle>
          <p>
            <FormattedMessage id={ golf.signInAccountMessage } />
          </p>
          <Link
            urlArgs={ props.urlArgs }
            href={ props.loginLink }
            data-eid={ eids.login }
            className='ux-button ux-button-primary ux-button-small btn btn-sm btn-filled btn-purchase'>
            <FormattedMessage id={ golf.login } />
          </Link>
        </div>
      </IntlProvider>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @api public
 */
SignIn.propTypes = {
  loginLink: PropTypes.string.isRequired,
  privateLabelId: PropTypes.number,
  market: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  manifest: PropTypes.string,
  urlArgs: PropTypes.object
};

export default SignIn;
